import { ClientJourneyContext } from '../services/deal/client-journey-context';
import { ResourceContextStore } from '../services/resource-context-store';

export async function refreshPropertyAddressAsync(
  clientJourneyContext: ClientJourneyContext,
  resourceContextStore: ResourceContextStore,
) {
  await resourceContextStore.flush();

  // reload addresses as they may have been updated
  const deal = clientJourneyContext.deal;

  deal.borrowers.forEach(borrower =>
    borrower.properties.forEach(property => resourceContextStore.removeByResource(property.address)),
  );

  await clientJourneyContext.loadPathForParents('$.borrowers.properties', deal.borrowers);
}

export async function refreshContactAddressAsync(
  clientJourneyContext: ClientJourneyContext,
  resourceContextStore: ResourceContextStore,
  borrowerId?: number,
) {
  await resourceContextStore.flush('address service flush');

  // reload addresses as they may have been updated
  const deal = clientJourneyContext.deal;
  const borrower = borrowerId ? deal.borrowers.find(b => b.id == borrowerId) : deal.borrowers[0];
  if (!borrower) return;

  borrower.contact.addresses.forEach(address => resourceContextStore.removeByResource(address));

  await clientJourneyContext.loadPathForParents('$.borrowers.contact.addresses', [borrower.contact]);
}

export async function refreshSubjectPropertyAddressAsync(
  clientJourneyContext: ClientJourneyContext,
  resourceContextStore: ResourceContextStore,
) {
  await resourceContextStore.flush();

  const subjectProperty = clientJourneyContext.deal.subjectProperty;
  resourceContextStore.removeByResource(subjectProperty.address);

  await clientJourneyContext.loadPathForParents('$.subjectProperty.address', [subjectProperty]);
}
